// extracted by mini-css-extract-plugin
export default {"user":"LhzV","status":"Fbtl"};